import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const header = (state: RootState) => state.common.header;

export const requestsCountSelector = createSelector(
  header,
  ({ requestsCount }) => requestsCount,
);

export const tasksCountSelector = createSelector(
  header,
  ({ tasksCount }) => tasksCount,
);
